import { getSystemInformation } from "./systemUtils";

const IOS_SAFARI_OPTIONS = { enableHighAccuracy: false, timeout: 15000, maximumAge: 0 };
const DEFAULT_OPTIONS = { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 };
const SAFARI_POSITION_DELAY_MS = 1000;
const IOS_SAFARI_TIMEOUT_MS = 10000;

const isIosSafariDevice = (systemInformation) => {
    return (systemInformation.platformType === 'Mobile' || systemInformation.platformType === 'Tablet')
        && (systemInformation.osName === 'macOS' || systemInformation.osName === 'iOS')
        && systemInformation.browserName === 'Safari';
};

const requestPosition = (onSuccess, onError, options) => {
    navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
};

export const getCurrentPositionByDevice = ({ onSuccess, onError, onTimeout, context = {} }) => {
    const systemInformation = getSystemInformation();

    if (isIosSafariDevice(systemInformation)) {
        const currentPosition = new Promise((resolve) => {
            setTimeout(() => {
                requestPosition(onSuccess, onError, IOS_SAFARI_OPTIONS);
                resolve();
            }, SAFARI_POSITION_DELAY_MS);
        });

        const timeOutGeolocation = new Promise(() => {
            setTimeout(() => onTimeout(), IOS_SAFARI_TIMEOUT_MS);
        });

        Promise.race([currentPosition, timeOutGeolocation]);
        return;
    }

    navigator.permissions.query({ name: 'geolocation' }).then(() => {
        requestPosition(onSuccess, onError, DEFAULT_OPTIONS);
    });
};
